import fr from './fr'
import en from './en'
import de from './de'

export default {
    fr,
    en,
    de
}